import http from "../../services/http";

const path = "api/activityanswer";

const gradeAnAnswer = ({ body, onSuccess, onError, onEnd, id = "" }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/${id}`,
        body,
        headers: {
          "x-auth-token": store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const getAnswer = ({
  body,
  onSuccess,
  onError,
  onEnd,
  id = "",
  query = {},
}) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.get({
        url: path + `/answer?query=${JSON.stringify(query)}`,
        body,
        headers: {
          "x-auth-token": store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

export { gradeAnAnswer, getAnswer };
